
export const DIMELO = 'DIMELO';
export const ODIGO = 'ODIGO';
export const isBlockDemiloFilter = (block) => block && block.source == DIMELO;
export const isBlockOdigoFilter = (block) => block && block.source == ODIGO;


// WEBPACK FOOTER //
// ./src/app/helpers/Dimelo.ts